import { render, staticRenderFns } from "./SignShapeImage.vue?vue&type=template&id=17396fa9&"
import script from "./SignShapeImage.vue?vue&type=script&lang=ts&"
export * from "./SignShapeImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports